export default "__VITE_ASSET__BTqsDIWb__"